// extracted by mini-css-extract-plugin
export default {"page":"FL","wrapper":"GL","text":"HL","icons":"IL","icon":"JL","icon_text":"KL","carousel_wrapper":"LL","slide":"ML","image":"NL","arrows":"OL","prev":"PL","modal_root":"QL","x_mark":"RL","modal":"SL","images":"TL","main_image":"UL","name":"VL"};
    if(module.hot) {
      // 1714442370119
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  